import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import {
    TwEnvioMuestraLaboratorioSolicitudViewModel,
    MotivoMuestraLaboratorioSolicitudViewModel,
    MotivoMuestraLaboratorioViewModel,
    SolicitudLaboratorioViewModel,
} from '../laboratorio.types';
import { TProductoSolicitudViewModel, TwEmbalajesViewModel } from '../../productos/productos.types';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-laboratorio-enviomuestras',
    templateUrl: './laboratorio-enviomuestras.component.html',
})
export class LaboratorioEnvioMuestrasComponent extends ComponentBase implements OnInit, OnChanges {
    public isCollapsedCabecera = false;

    motivosMuestraLaboratorio: MotivoMuestraLaboratorioSolicitudViewModel[];
    productosMuestraLaboratorio: TProductoSolicitudViewModel[];
    embalajesMuestraLaboratorio: TwEmbalajesViewModel[];

    @Input() formGroup: FormGroup;
    @Input() solicitudLaboratorio: SolicitudLaboratorioViewModel;
    @Input() esPerfilInspector = false;
    @Input() esPerfilConsultasyLaboratorio = false;
    @Input() listMotivos: MotivoMuestraLaboratorioViewModel[];
    @Input() listProductos: TProductoSolicitudViewModel[];
    @Input() listEmbalajes: TwEmbalajesViewModel[];
    @Input() listMotivosSolicitud: MotivoMuestraLaboratorioSolicitudViewModel[];
    @Input() hayEnvioMuestrasInspector = false;
    @Input() envioMuestras: TwEnvioMuestraLaboratorioSolicitudViewModel;
    @Input() enviandoMuestras = false;

    @Output() addMotivosMuestraLaboratorio = new EventEmitter<MotivoMuestraLaboratorioSolicitudViewModel[]>();
    @Output() addProductosMuestraLaboratorio = new EventEmitter<TProductoSolicitudViewModel[]>();
    @Output() addEmbalajesMuestraLaboratorio = new EventEmitter<TwEmbalajesViewModel[]>();

    constructor(protected authService: AuthService, protected notificacionService: NotificationService, protected exceptionHandler: ExceptionManager) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.form = this.formGroup;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.listMotivosSolicitud?.currentValue) {
            this.motivosMuestraLaboratorio = this.listMotivosSolicitud;
        }
        if (changes?.envioMuestras?.currentValue) {
            if (this.hayEnvioMuestrasInspector) {
                this.formGroup.controls['IdMotivo'].disable();
                this.formGroup.controls['IdProducto'].disable();
                this.formGroup.controls['IdEmbalaje'].disable();
                this.productosMuestraLaboratorio = this.solicitudLaboratorio.TProductoSolicitudCollection.filter(p => p.MuestraLaboratorio === true);
                this.embalajesMuestraLaboratorio = this.solicitudLaboratorio.TwEmbalajesCollection.filter(e => e.MuestraLaboratorio === true);
                this.updateForm();
            }
        }
    }

    private updateForm(): void {
        this.formGroup.patchValue({
            IdMotivo: null,
            IdProducto: null,
            IdEmbalaje: null,
        });
    }

    onAddMotivo(): void {
        if (this.form.value.IdMotivo != null && this.form.value.IdMotivo > 0) {
            this.removeValidators('IdMotivo');
            let currentMotivo = new MotivoMuestraLaboratorioSolicitudViewModel();
            currentMotivo.IdMotivo = this.form.value.IdMotivo;
            currentMotivo.IdSolicitud = this.solicitudLaboratorio.Id;

            if (this.motivosMuestraLaboratorio == null) {
                this.motivosMuestraLaboratorio = new Array<MotivoMuestraLaboratorioSolicitudViewModel>();
            }
            //Comprobamos que no esté ya incluido
            let yaIncluido = this.motivosMuestraLaboratorio.find(m => m.IdMotivo == currentMotivo.IdMotivo);

            if (!yaIncluido) {
                //Si no está incluido todavía, actualizamos el listbox
                const mot = this.listMotivos.find(m => m.Id == currentMotivo.IdMotivo);
                currentMotivo.DescripcionMotivo = mot!.Descripcion;

                this.motivosMuestraLaboratorio.push(currentMotivo);

                this.removeValidators('IdMotivo');
                this.form.patchValue({
                    IdMotivo: null,
                });
                this.addMotivosMuestraLaboratorio.emit(this.motivosMuestraLaboratorio);
            }
        }
    }

    onDeleteMotivo(item: MotivoMuestraLaboratorioSolicitudViewModel): void {
        this.motivosMuestraLaboratorio.splice(this.motivosMuestraLaboratorio.indexOf(item), 1);
        if (this.motivosMuestraLaboratorio.length == 0) {
            this.addValidator('IdMotivo', Validators.required);
        }
    }

    onAddProducto(): void {
        if (this.form.value.IdProducto != null && this.form.value.IdProducto > 0) {
            this.removeValidators('IdProducto');
            let currentProducto = new TProductoSolicitudViewModel();
            currentProducto.Id = this.form.value.IdProducto;

            if (this.productosMuestraLaboratorio == null) {
                this.productosMuestraLaboratorio = new Array<TProductoSolicitudViewModel>();
            }
            //Comprobamos que no esté ya incluido
            let yaIncluido = this.productosMuestraLaboratorio.find(m => m.Id == currentProducto.Id);

            if (!yaIncluido) {
                const prod = this.listProductos.find(item => item.Id === this.form.value.IdProducto);
                if (!prod) {
                    return;
                }
                //Si no está incluido todavía, actualizamos el listbox
                currentProducto.MuestraLaboratorio = true;
                currentProducto.IdTaricProductoNombreCientificoNombreComun = prod.IdTaricProductoNombreCientificoNombreComun!;

                this.productosMuestraLaboratorio.push(currentProducto);

                this.removeValidators('IdProducto');
                this.form.patchValue({
                    IdProducto: null,
                });
                this.addProductosMuestraLaboratorio.emit(this.productosMuestraLaboratorio);
            }
        }
    }

    onDeleteProducto(item: TProductoSolicitudViewModel): void {
        this.productosMuestraLaboratorio.splice(this.productosMuestraLaboratorio.indexOf(item), 1);

        if (this.productosMuestraLaboratorio.length == 0) {
            this.addValidator('IdProducto', Validators.required);
        }
    }

    onAddEmbalaje(): void {
        if (this.form.value.IdEmbalaje != null && this.form.value.IdEmbalaje > 0) {
            this.removeValidators('IdEmbalaje');
            let currentEmbalaje = new TwEmbalajesViewModel();
            currentEmbalaje.Id = this.form.value.IdEmbalaje;

            if (this.embalajesMuestraLaboratorio == null) {
                this.embalajesMuestraLaboratorio = new Array<TwEmbalajesViewModel>();
            }
            //Comprobamos que no esté ya incluido
            let yaIncluido = this.embalajesMuestraLaboratorio.find(m => m.Id == currentEmbalaje.Id);

            if (!yaIncluido) {
                const emb = this.listEmbalajes.find(item => item.Id === this.form.value.IdEmbalaje);
                if (!emb) {
                    return;
                }
                //Si no está incluido todavía, actualizamos el listbox
                currentEmbalaje.MuestraLaboratorio = true;
                currentEmbalaje.IdTaricEmbalajeDescripcion = emb.IdTaricEmbalajeDescripcion;

                this.embalajesMuestraLaboratorio.push(currentEmbalaje);

                this.removeValidators('IdEmbalaje');
                this.form.patchValue({
                    IdEmbalaje: null,
                });
                this.addEmbalajesMuestraLaboratorio.emit(this.embalajesMuestraLaboratorio);
            }
        }
    }

    onDeleteEmbalaje(item: TwEmbalajesViewModel): void {
        this.embalajesMuestraLaboratorio.splice(this.embalajesMuestraLaboratorio.indexOf(item), 1);

        if (this.embalajesMuestraLaboratorio.length == 0) {
            this.addValidator('IdEmbalaje', Validators.required);
        }
    }
}
